import g from '#core/global';
import load from '#core/load';


// Store publicly accessible items in pattern-specific key in global object
const state = window.teal_state = window.teal_state || {};
state.sandbox = state.sandbox || {};
state.sandbox.has_all_loaded = false;

const pattern_$ = '.sandbox';

let has_pattern = false;
let $pattern = null;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('sandbox')) return false;
		
		load.content(() => {
			has_pattern = assign_elements();
			if (!has_pattern) return false;
		});
		load.all(() => {
			has_pattern = assign_elements();
			if (!has_pattern) return false;
			
			// Access public items directly from state object
			state.sandbox.has_all_loaded = true;
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_pattern) return true;
	
	$pattern = document.querySelector(pattern_$);
	if (!$pattern) return false;
	
	document.addEventListener(g.click_e, e => {
		if (!e.target.closest(pattern_$)) return;
		
		// Handle click
	});
	
	return true;
}
